// extracted by mini-css-extract-plugin
module.exports = {"trustpilotWidget":"trust-pilot_trustpilotWidget__S1Kij"};